import { createContext } from 'react';
export interface BoilerPermissionContextType {
  hasBoilerPermissions: boolean;
}

export const BoilerPermissionContext = createContext<
  BoilerPermissionContextType
>({ hasBoilerPermissions: false });
